import Vue from 'vue'

const state = new Vue({
  data() {
    return {
      state: {
        app: {
          test: "Hello",
          apiUrl: process.env.VUE_APP_API_URL,
          // apiUrl: "https://welcome-backend.birkenbeul.rocks",
          userId: null
        },
        events: []
      }
    }
  },
  mounted() {
    console.log(this.$store)
  },
  computed: {
    compTest() {
    }
  },
  methods: {
    
  }
})

export const store = state
